<template>
  <div>
    <div class="pa-6">
      <v-container fluid>
        <v-row>
          <v-col class="yCenter">
            <h2 class="primary--text pr-5">{{ $t('common.common_form') }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <NoneChevronExpansionPanel>
              <template #header>
                <div class="headerAreaStyle d-flex align-center px-9">
                  <div class="titleStyle">
                    {{ $t('common.common_form-type') }}
                  </div>
                  <div class="px-5">
                    <v-select
                      v-model="ledgerType"
                      :items="getLedgerTypes"
                      item-text="text"
                      item-value="value"
                      filled
                      dense
                      outlined
                      class="original-selectbox headerAreaselectbox"
                      hide-details
                      :placeholder="$t('order.order_order')"
                      height="32px"
                    />
                  </div>
                  <div
                    class="mr-1"
                    v-if="
                      selectedLedgerTypeItems &&
                      selectedLedgerTypeItems.isShowHideUnusedCurrencyCheck
                    "
                  >
                    <v-checkbox
                      v-model="item.currency"
                      :label="$t('common.common_hide-unused-currencies')"
                    />
                  </div>
                  <div
                    class="ml-4"
                    v-if="
                      selectedLedgerTypeItems &&
                      selectedLedgerTypeItems.isShowHideUnusedProductCheck
                    ">
                    <v-checkbox
                      v-model="item.product"
                      :label="$t('common.common_hide-unused-products')"
                    />
                  </div>
                </div>
              </template>
              <template #content>
                <div class="ledger-Sheet-select">
                  <LedgerSheetInputForm
                    :ledgerType="selectedLedgerTypeItems"
                    @dataOutput="dataOutput"
                  />
                </div>
              </template>
            </NoneChevronExpansionPanel>
          </v-col>
        </v-row>
        <v-row v-if="LedgerSheetName && LedgerSheetName !== 'combined-bill'">
          <v-col>
            <NoneChevronExpansionPanel>
              <template #header>
                <div class="headerAreaStyle d-flex align-center px-9 pr-8">
                  <v-row align="center">
                    <v-col cols="8">
                      <span class="titleStyle pr-6"
                        >{{ $t(ledgerSheetDisplayName)
                        }}{{ $t('common.common_form') }}</span
                      >
                      <span class="periodTextStyle">
                        {{ $t('common.common_period') }}：
                        <span
                          v-if="
                            LedgerSheetName != 'month-end-stock' &&
                            datePeriod.start &&
                            datePeriod.end
                          "
                          >{{ datePeriod.start }}〜{{ datePeriod.end }}</span
                        >
                        <span
                          v-else-if="
                            LedgerSheetName == 'month-end-stock' &&
                            inputData.ledgerInfoline1.orderMonth
                          "
                          >{{ inputData.ledgerInfoline1.orderMonth }}</span
                        >
                      </span>
                      <div class="max-data-message">
                        {{ $t('common.common_ledger-sheet-max-data-message') }}
                      </div>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-end pr-0">
                      <NormalButton
                        text="common.common_pdf-download"
                        height="32px"
                        width="138px"
                        textSize="14px"
                        class="text-right mr-5"
                        :disabled="
                          downloadUrlBase && enableDownlaodPDF ? false : true
                        "
                        @click="downloadFile(0)"
                      />
                      <NormalButton
                        text="common.common_csv-download"
                        height="32px"
                        width="138px"
                        textSize="14px"
                        class="text-right"
                        :disabled="
                          downloadUrlBase && enableDownlaodCSV ? false : true
                        "
                        @click="downloadFile(2)"
                      />
                    </v-col>
                  </v-row>
                </div>
              </template>
              <template #content v-if="previewUrl">
                <iframe
                  :src="previewUrl"
                  class="ledger-Sheet-preview"
                  frameborder="0"
                />
              </template>
            </NoneChevronExpansionPanel>
          </v-col>
        </v-row>
        <v-row v-if="LedgerSheetName === 'combined-bill'">
          <v-col>
            <NoneChevronExpansionPanel>
              <template #content>
                <v-data-table
                  :headers="invoiceTableHeaders"
                  :items="Object.values(getCombinedBillListFromState())"
                  :items-per-page="-1"
                  hide-default-footer
                  :no-data-text="$t('common.common_not-register')"
                  class="rounded-lg"
                  :options.sync="tableOptions"
                >
                  <!-- 作成日時 -->
                  <template #[`item.createdDate`]="{ item }">
                    <div class="text-center">
                      {{ item.createdAt || '-' }}
                    </div>
                  </template>
                  <!-- 請求日 -->
                  <template #[`item.invoiceDate`]="{ item }">
                    <div class="text-center">
                      {{ item.billDate || '-' }}
                    </div>
                  </template>
                  <!-- 会社顧客名 -->
                  <template #[`item.customerName`]="{ item }">
                    <div class="font-weight-bold">
                      {{ item.customerName || '-' }}
                    </div>
                  </template>
                  <!-- 請求金額 -->
                  <template #[`item.invoiceAmount`]="{ item }">
                    <div class="text-right">
                      {{
                        item.billAmount
                          ? Number(item.billAmount).toLocaleString() +
                            getCurrencyName(item.currencyId)
                          : '-'
                      }}
                    </div>
                  </template>
                  <!-- ダウンロード回数 -->
                  <template #[`item.downloadCount`]="{ item }">
                    <div class="text-center">
                      {{
                        item.downloadCount
                          ? item.downloadCount.toLocaleString()
                          : '-'
                      }}
                    </div>
                  </template>
                  <!-- ダウンロード期限（10年後の日付を表示） -->
                  <template #[`item.downloadDeadline`]="{ item }">
                    <div class="text-center">
                      {{
                        new Date(
                          new Date(item.createdAt).setFullYear(
                            new Date(item.createdAt).getFullYear() + 10
                          )
                        )
                          .toISOString()
                          .split('T')[0] || '-'
                      }}
                    </div>
                  </template>
                  <!-- 操作 -->
                  <template #[`item.actions`]="{ item }">
                    <v-row justify="center">
                      <v-col cols="auto" class="text-center px-0">
                        <NormalButton
                          text="sale.sale_invoice-download"
                          height="32px"
                          width="48px"
                          @click.native="
                            downloadInvoice(item.combinedBillLedgerSheetId)
                          "
                        />
                      </v-col>
                    </v-row>
                  </template>
                </v-data-table>
              </template>
            </NoneChevronExpansionPanel>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { NoneChevronExpansionPanel } from '@/components/items'
import { NormalButton } from '@/components/items'
import LedgerSheetInputForm from './LedgerSheetInputForm'
import _cloneDeep from 'lodash/cloneDeep'
import { LedgerTypes } from './LedgerSheetInputItems'
import { mapActions, mapGetters } from 'vuex'
import { currencyUtil } from '@/util'
import { i18n } from '@/main'

export default {
  components: {
    NoneChevronExpansionPanel,
    NormalButton,
    LedgerSheetInputForm
  },
  data: () => {
    return {
      ledgerType: '',
      LedgerSheetName: '',
      inputData: {},
      datePeriod: { start: '', end: '' },
      item: {
        currency: true,
        ledgerType: LedgerTypes,
        product: true
      },
      previewUrl: '',
      downloadUrlBase: '',
      enableDownlaodPDF: true,
      enableDownlaodCSV: true,
      csvDownloadAlert: false,
      invoiceTableHeaders: [
        {
          text: i18n.tc('common.common_create-date'),
          value: 'createdDate',
          align: 'center',
          sortable: false
        },
        {
          text: i18n.tc('sale.sale_bill-date'),
          value: 'invoiceDate',
          align: 'center',
          sortable: false
        },
        {
          text: i18n.tc('sale.sale_customer-name'),
          value: 'customerName',
          align: 'center',
          sortable: false
        },
        {
          text: i18n.tc('sale.sale_invoice_amount'),
          value: 'invoiceAmount',
          align: 'right',
          sortable: false
        },
        {
          text: i18n.tc('common.common_download-count'),
          value: 'downloadCount',
          align: 'center',
          sortable: false
        },
        {
          text: i18n.tc('common.common_download-limit'),
          value: 'downloadDeadline',
          align: 'center',
          sortable: false
        },
        {
          text: i18n.tc('payment.payment_operation'),
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ],
      tableOptions: {
        sortBy: ['combinedBillLedgerSheetId'],
        sortDesc: [true]
      }
    }
  },
  computed: {
    ...mapGetters('User', ['authority']),
    getLedgerTypes() {
      const result = this.item.ledgerType
        .filter((ele) => {
          if (!this.authority.isFunction1) {
            return ele.value !== 'combined-bill'
          }
          return true
        })
        .map((ele) => {
          const tmp = { ...ele }
          tmp.text = this.$t(ele.text)
          return tmp
        })
      return result
      // return this.item.ledgerType
    },
    selectedLedgerTypeItems() {
      return this.item.ledgerType.find((d) => d.value === this.ledgerType)
    },
    ledgerSheetDisplayName() {
      if (this.LedgerSheetName) {
        const ledgerSheet = this.item.ledgerType.find(
          (element) => element.value === this.LedgerSheetName
        )
        return ledgerSheet.text
      }
      return ''
    },
    ...mapGetters('Product', ['getProductListFromState'])
  },
  async mounted() {
    this.ledgerType = 'order'
    await this.getProductListFromApi({})
    this.csvDownloadAlert = this.getProductListFromState.find(
      (ele) => !isNaN(ele.productNumber)
    )
      ? true
      : false
  },
  methods: {
    ...mapActions('Product', ['getProductListFromApi']),
    ...mapActions('Common', ['getLedgerSheet', 'setIsLoading']),
    ...mapGetters('Common', ['getLedgerSheetFromState']),
    ...mapActions('CombinedBill', [
      'getCombinedBillListFromApi',
      'getCombinedBillDownloadFromApi'
    ]),
    ...mapGetters('CombinedBill', ['getCombinedBillListFromState']),
    getLedgerSheetName() {
      const ledgerSheet = this.item.ledgerType.find(
        (element) => element.value === this.ledgerType
      )
      if (ledgerSheet) {
        this.LedgerSheetName = ledgerSheet.value
      }
    },
    async getRequestUrl(type) {
      let requestUrlBase = ''
      if (this.LedgerSheetName === 'combined-bill') {
        requestUrlBase = `${process.env.VUE_APP_WEB_API_BASE_URL}/api/order/ledger-sheet/combined-bill/index?`
        const customerIds = this.inputData.ledgerInfoline1.customers?.map(
          (ele) => {
            return ele.value
          }
        )
        const ret = await this.getCombinedBillListFromApi({
          createDateStart: this.inputData.ledgerInfoline1.createDate.start,
          createDateEnd: this.inputData.ledgerInfoline1.createDate.end,
          billDateStart: this.inputData.ledgerInfoline1.billDate.start,
          billDateEnd: this.inputData.ledgerInfoline1.billDate.end,
          customerIds: customerIds && customerIds.length > 0 ? customerIds.join() : null,
          currencyId: this.inputData.ledgerInfoline1.currency
            ? this.inputData.ledgerInfoline1.currency.value
            : null,
          billingAmountMin: this.inputData.ledgerInfoline1.amount.min,
          billingAmountMax: this.inputData.ledgerInfoline1.amount.max,
        })
        return
      } else {
        requestUrlBase = `${process.env.VUE_APP_WEB_API_BASE_URL}/api/order/ledger-sheet/${this.LedgerSheetName}?`
      }

      // 帳票作成日のリクエストパラメータを取得
      const { start, end } = this.inputData.ledgerInfoline1.createDate;

      // 期間のパラメータ名がAPIごとに異なるので選択された帳票タイプにより動的に設定
      const periodParams = this.getPeriodParamName()

      // 複数選択項目の整形
      const supplierIds = this.inputData.ledgerInfoline1.supplierId?.map(
        (ele) => {
          return ele.value
        }
      )
      const supplierText = supplierIds ? supplierIds.join() : ''
      const customerIds = this.inputData.ledgerInfoline1.customers?.map(
        (ele) => {
          return ele.value
        }
      )
      const customerText = customerIds ? customerIds.join() : ''
      const shipStorageIds = this.inputData.ledgerInfoline1.shipStorageIds?.map(
        (ele) => {
          return ele.value
        }
      )
      const shipStorageText = shipStorageIds ? shipStorageIds.join() : ''
      const loadingStorageIds =
        this.inputData.ledgerInfoline1.loadingStorageIds?.map((ele) => {
          return ele.value
        })
      const loadingStorageText = loadingStorageIds
        ? loadingStorageIds.join()
        : ''
      const adjustStorageIds =
        this.inputData.ledgerInfoline1.adjustStorageIds?.map((ele) => {
          return ele.value
        })
      const adjustStorageText = adjustStorageIds ? adjustStorageIds.join() : ''
      const storageIds = this.inputData.ledgerInfoline1.storageIds?.map(
        (ele) => {
          return ele.value
        }
      )
      const storageText = storageIds ? storageIds.join() : ''

      // line2のパラメータの整形
      let ledgerInfoline2Param = ''
      if (this.inputData.ledgerInfoline2) {
        Object.keys(this.inputData.ledgerInfoline2).forEach((key) => {
          ledgerInfoline2Param += this.inputData.ledgerInfoline2[key]
            ? `${key}=${this.inputData.ledgerInfoline2[key].value}&`
            : ''
        })
      }

      // line3のパラメータ整形
      let ledgerInfoline3Param = this.inputData.ledgerInfoline3.reduce(
        (res, cur) => {
          const val = cur.check ? 1 : 0
          return `${res}${cur.param}=${val}&`
        },
        ''
      )

      let requestUrl = `${requestUrlBase}${ledgerInfoline3Param}${ledgerInfoline2Param}`
      if (supplierText) requestUrl += `supplierIds=${supplierText}&`
      if (customerText) requestUrl += `customerIds=${customerText}&`
      if (shipStorageText) requestUrl += `shipStorageIds=${shipStorageText}&`
      if (loadingStorageText)
        requestUrl += `loadingStorageIds=${loadingStorageText}&`

      if (adjustStorageText)
        requestUrl += `adjustStorageIds=${adjustStorageText}&`
      if (storageText) requestUrl += `storageIds=${storageText}&`

      requestUrl += `displayMethod=${this.inputData.ledgerInfoline1.displayMethod}&`
      requestUrl += `adjustmentAmountDisplay=${this.inputData.ledgerInfoline1.adjustmentAmountDisplay}&`
      // 期間
      if (this.LedgerSheetName !== 'month-end-stock') {
        requestUrl += `${periodParams.start}=${this.inputData.ledgerInfoline1.orderDate.start}&${periodParams.end}=${this.inputData.ledgerInfoline1.orderDate.end}&`
      } else {
        // LS11 月末在庫帳票だけ期間が月ごとの設定になるので切り分け
        requestUrl += `${periodParams.start}=${this.inputData.ledgerInfoline1.orderMonth}&`
      }
      requestUrl += `isHideUnusedCurrency=${this.item.currency ? 1 : 0}&`
      if (this.item.product) {
        requestUrl += `isHideUnusedProduct=1&`
      }
      requestUrl += `lang=${this.$i18n.locale}&`
      // プレビューされているものをダウンロードする必要があるため出力タイプ以外が設定されたURLを保持する
      this.downloadUrlBase = requestUrl

      requestUrl += `outputType=${type}`
      this.previewUrl = requestUrl
    },
    // 通貨名の取得
    getCurrencyName(currencyId) {
      return currencyUtil.findCurrencyNameById(currencyId).unitName
    },
    getPeriodParamName() {
      switch (this.LedgerSheetName) {
        case 'sale':
        case 'sale-payment':
          return { start: 'saleStartDate', end: 'saleEndDate' }
        case 'order':
        case 'order-payment':
          return { start: 'orderStartDate', end: 'orderEndDate' }
        case 'loading':
          return { start: 'loadingStartDate', end: 'loadingEndDate' }
        case 'ship':
          return { start: 'shipStartDate', end: 'shipEndDate' }
        case 'refund':
          return { start: 'refundStartDate', end: 'refundEndDate' }
        case 'storage-move':
          return { start: 'storageMoveStartDate', end: 'storageMoveEndDate' }
        case 'stock-adjust':
          return { start: 'stockAdjustStartDate', end: 'stockAdjustEndDate' }
        case 'month-end-stock':
          return { start: 'targetMonth', end: 'targetMonth' }
        case 'income-statement':
          return {
            start: 'accrualStartDate',
            end: 'accrualEndDate'
          }
        case 'cost-floating-table':
          return { start: 'orderStartDate', end: 'orderEndDate' }
        case 'combined-bill':
          return { start: 'targetMonth', end: 'targetMonth' }
      }
    },
    async dataOutput(inputData, type) {
      this.previewUrl = ''
      await this.$nextTick()
      this.inputData = _cloneDeep(inputData)
      this.datePeriod = this.inputData.ledgerInfoline1.orderDate
      this.getLedgerSheetName()
      this.getRequestUrl(type)
      this.enableDownlaodPDF = true
      this.enableDownlaodCSV = true
    },
    async downloadFile(type) {
      // 商品マスタに商品番号が数値のみの商品が存在する場合CSVダウンロード時にアラート
      if (type == 2 && this.csvDownloadAlert) {
        alert(`ご注意ください！
商品番号が数値のみで登録されているため、文字列変換せずCSVからエクセル形式に保存すると誤表記されます。`)
      }
      this.setIsLoading(true)
      if (
        await this.getLedgerSheet(`${this.downloadUrlBase}outputType=${type}`)
      ) {
        const response = this.getLedgerSheetFromState()
        if (
          response.header['content-type'] === 'application/pdf' ||
          response.header['content-type'] === 'application/octet-stream'
        ) {
          const downloadLink = document.createElement('a')
          const contentDisposition = response.header['content-disposition']
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          const matches = filenameRegex.exec(contentDisposition)
          downloadLink.download = matches[1].replace(/['"]/g, '')
          downloadLink.href = URL.createObjectURL(
            new Blob([response.data], {
              type: response.header['content-type']
            })
          )
          downloadLink.click()
        } else if (response.header['content-type'] === 'application/json') {
          alert(this.$t('common.common_ledger-sheet-big-data-alert'))
          if (type == 0) {
            this.enableDownlaodPDF = false
          } else if (type == 2) {
            this.enableDownlaodCSV = false
          }
        }
      } else {
        this.enableDownlaodPDF = false
        this.enableDownlaodCSV = false
      }
      this.setIsLoading(false)
    },
    async downloadInvoice(id) {
      //alert(`請求書（ID: ${item.invoiceId}）をダウンロードします。`)
      // ダウンロード処理をここに実装
      const ret = await this.getCombinedBillDownloadFromApi({
        combinedBillLedgerSheetId: id
      })
      //const requestUrlBase = `${process.env.VUE_APP_WEB_API_BASE_URL}/api/order/ledger-sheet/combined-bill/download?combinedBillLedgerSheetId=1`
      //this.inputedValue.submitFunc(requestUrlBase)
    }
  }
}
</script>

<style scoped lang="scss">
.titleStyle {
  font-size: 18px;
  font-weight: bold;
}
.periodTextStyle {
  font-size: 14px;
  font-weight: bold;
}
.headerAreaStyle {
  height: 70px;
}
.headerAreaselectbox {
  width: 202px;
  ::v-deep fieldset {
    border: none !important;
  }
}

.ledger-Sheet-select {
  margin: 8px 20px 20px 36px;
}

.ledger-Sheet-preview {
  width: 100%;
  height: 500px;
}
.max-data-message {
  display: inline-block;
  font-size: 12px;
  vertical-align: middle;
  width: 260px;
  padding-left: 10px;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
